module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-mitsu-24.63415a01.jpg";